import appConstants from "../../../../../appConstants";
import { TextFieldEditor } from "../../../../dataGrid/cellEditors";
import { RadioRenderer, DisabledButtonRenderer }  from "../../../../dataGrid/cellRenderer";

export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static isEditable(params){
      return !params.data.isMaster;
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ScenarioExplorer,
      keyColumn: "scenarioId",
      columns: [
        {
          headerName: "Scenario ID",
          field: "scenarioId",
          headerTooltip: "Scenario ID",
          minWidth: appConstants.columnWidth.SCENARIO_ID,
          maxWidth: appConstants.columnWidth.SCENARIO_ID
        },
        {
          headerName: "Name",
          field: "scenarioName",
          headerTooltip: "Scenario Name",
          editable: GridConfig.isEditable,
          cellEditorFramework: TextFieldEditor,
          cellRendererFramework: params =>{
            if(params.data.isDefault){
              return (
                <div>
                  <span class="activeContent">
                    <div>{params.value}</div>
                  </span>
                  <span class="activeContentButton">Default</span>
                </div>
              );
            }else{
              return <div>{params.value}</div>
            }
          },
          tooltipField: "scenarioName"
        },
        {
          headerName: "Description",
          field: "scenarioDescription",
          headerTooltip: "Scenario Description",
          editable: GridConfig.isEditable,
          cellEditorFramework: TextFieldEditor

        },
        {
            headerName: "Active",
            field: "isActive",
            headerTooltip: "Active",
            cellRendererFramework: params =>{
                if(params.data.isMaster){
                  return <DisabledButtonRenderer /> // Using a component to show disabled button here, unable to find a way to use normal string and component togather as a renderer
                }else{
                 return <RadioRenderer {...params} disabled={Boolean(params.data.disabled)} />
                }
            }
          }
      ]
    }
  }
}

